export enum UpsertPartBomStep {
  DETAILS = 'details',
  TAXONOMY = 'taxonomy',
}

export enum UpsertPartBomCreateType {
  NEW = 'new',
  EXISTING = 'existing',
}
